var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotifiError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5940_2189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.72867 0 0 6.72867 0 15C0 23.2713 6.72867 30 15 30C23.2713 30 30 23.2713 30 15C30 6.72867 23.2713 0 15 0Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6195 20.1815C23.2935 20.8559 23.2935 21.9455 22.6195 22.6198C22.2832 22.9561 21.8419 23.125 21.4002 23.125C20.9588 23.125 20.5174 22.9561 20.1812 22.6198L15 17.4382L9.8188 22.6198C9.48257 22.9561 9.0412 23.125 8.59983 23.125C8.15814 23.125 7.71677 22.9561 7.38054 22.6198C6.70649 21.9455 6.70649 20.8559 7.38054 20.1815L12.562 15.0002L7.38054 9.81888C6.70649 9.14449 6.70649 8.05493 7.38054 7.38055C8.05491 6.70648 9.14444 6.70648 9.8188 7.38055L15 12.5622L20.1812 7.38055C20.8556 6.70648 21.9451 6.70648 22.6195 7.38055C23.2935 8.05493 23.2935 9.14449 22.6195 9.81888L17.4379 15.0002L22.6195 20.1815Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5940_2189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotifiError);
export default __webpack_public_path__ + "static/media/IconNotifiError.c24b57e2294c949aa87018fd14b0e252.svg";
export { ForwardRef as ReactComponent };